// Espacio de trabajo activo, POR PESTAÑA (sessionStorage está aislado por
// pestaña). El cliente Supabase envía este id en la cabecera `x-team-id` de
// cada petición, y la RLS lo valida contra la membresía. Mantener este módulo
// sin dependencias (lo importa supabaseClient.ts).

const KEY = 'bk_active_team';

export function getActiveTeamId(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setActiveTeamId(id: string | null): void {
  try {
    if (id) sessionStorage.setItem(KEY, id);
    else sessionStorage.removeItem(KEY);
  } catch {
    /* sessionStorage no disponible (modo privado extremo): se ignora */
  }
}
